import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { ISolicitudDeuda } from "../interfaces/erp/solicitud_deuda/solicitud_deuda.interface"
import { calcColorStatusGeneral, emptyCell, formatDateWithTime } from "../utils"
import { EstadoComponente } from "../components/ui"
import { EstadoSolicitudDeudaENUM } from "../constants"
import InfoUser from "../components/ui/InfoUser/InfoUser"

interface TableColumnsSolicitudDeudaProps {
  estado_solicitud: EstadoSolicitudDeudaENUM
}

export const useTableColumnsSolicitudDeuda = ({
  
}: TableColumnsSolicitudDeudaProps) => {

  const columnsBase = useMemo<MRT_ColumnDef<ISolicitudDeuda>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
    },
    {
      accessorKey: 'razon_social',
      header: 'Razon social',
      size: 200,
      Cell: ({ row }) => emptyCell(row.original.razon_social)
    },
    {
      accessorKey: 'deuda',
      header: 'Pendiente por cobrar',
      Cell: ({ row }) => row.original.deuda ? `$${row.original.deuda}` : 'N/A'

    },
    {
      accessorKey: 'estado_solicitud',
      header: 'estado solicitud',
      size: 200,
      Cell: ({ row }) => <EstadoComponente 
      backgroundColor={calcColorStatusGeneral(row.original.estado_solicitud)}
       texto={row.original.estado_solicitud} />
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'fecha creacion',
      size: 200,
      Cell: ({ row }) => formatDateWithTime(row.original.fecha_creacion)
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 200,
      Cell: ({ row }) => (
        <InfoUser user={row.original.user_create}
        />
      )
    },
    {
      accessorKey: 'canal_venta_create',
      header: 'canal venta',
      size: 200,
    }

  ], [])

  return {
    columnsBase
  }


}